
define('text!fusion/ui/controls/fusion-linkexpander.html',[],function () { return '<div class="fusion-text-link-expander">\r\n    <dl class="expander">\r\n       <!-- ko transclude: \'fusion-linkexpander-panel\' --> <!-- /ko -->\r\n    </dl>\r\n</div>';});

